module.exports = __webpack_public_path__ + "img/demo1.a1173a22.png";